import React from "react";

import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import axios from '../../axios/axiosconf';
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

function Settings() {

    const [client, setClient] = useState([]);
    const [permisos, setPermisos] = useState([]);
    let userdata = [];
    let clientData = [];

    useEffect(()=>{

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
            setPermisos(userdata.up);
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        }
    },[]);

    return (
        
        <div className="hold-transition">
            <Header />
            <Aside activelink="settings" />
            
            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-8">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><Link to="/home">Home</Link></li>
                                    <li className="breadcrumb-item">Configuración</li>
                                </ol>
                            </div>
                        </div>
                        <div className="row mb-2">
                            <div className="col-sm-8">
                                <h1 className="m-0">Configuración</h1>
                            </div>
                        </div>
                    </div>
                </div>
                <section className="content" >
                    <div className="container-fluid">
                        <div className="row">
                            {permisos.includes('administrarPersonalProveedores') && (
                                <div className="col-lg-3 col-6">
                                    <div className="small-box bg-custom-dark">
                                        <div className="inner">
                                            <h3>&nbsp;</h3>
                                            <p>Personal y Proveedores</p>
                                        </div>
                                        <div className="icon">
                                            <i className="fas fa-users"></i>
                                        </div>
                                        <Link to="/personal-proveedores" className="small-box-footer">
                                            Administrar <i className="fas fa-arrow-circle-right"></i>
                                        </Link>
                                    </div>
                                </div>
                            )}

                            {permisos.includes('administrarPlantillas') && (
                                <div className="col-lg-3 col-6">
                                    <div className="small-box bg-custom-dark">
                                        <div className="inner">
                                            <h3>&nbsp;</h3>
                                            <p>Plantillas</p>
                                        </div>
                                        <div className="icon">
                                            <i className="fas fa-file-alt"></i>
                                        </div>
                                        <Link to="/administrar-plantillas" className="small-box-footer">
                                            Administrar <i className="fas fa-arrow-circle-right"></i>
                                        </Link>
                                    </div>
                                </div>
                            )}

                            {permisos.includes('administrarTratamientos') && (
                                <div className="col-lg-3 col-6">
                                    <div className="small-box bg-custom-dark">
                                        <div className="inner">
                                            <h3>&nbsp;</h3>
                                            <p>Módulo Contable</p>
                                        </div>
                                        <div className="icon">
                                            <i className="fas fa-calculator"></i>
                                        </div>
                                        <Link to="/administrar-tratamientos" className="small-box-footer">
                                            Administrar <i className="fas fa-arrow-circle-right"></i>
                                        </Link>
                                    </div>
                                </div>
                            )}

                            {permisos.includes('administrarParametrosAgenda') && (
                                <div className="col-lg-3 col-6">
                                    <div className="small-box bg-custom-dark">
                                        <div className="inner">
                                            <h3>&nbsp;</h3>
                                            <p>Parámetros de Agenda</p>
                                        </div>
                                        <div className="icon">
                                            <i className="fas fa-calendar-alt"></i>
                                        </div>
                                        <Link to="/parametros-agenda" className="small-box-footer">
                                            Configurar <i className="fas fa-arrow-circle-right"></i>
                                        </Link>
                                    </div>
                                </div>
                            )}

                            {permisos.includes('administrarParametrosSistema') && (
                                <div className="col-lg-3 col-6">
                                    <div className="small-box bg-custom-dark">
                                        <div className="inner">
                                            <h3>&nbsp;</h3>
                                            <p>Parámetros del Sistema</p>
                                        </div>
                                        <div className="icon">
                                            <i className="fas fa-cogs"></i>
                                        </div>
                                        <Link to="/parametros-sistema" className="small-box-footer">
                                            Configurar <i className="fas fa-arrow-circle-right"></i>
                                        </Link>
                                    </div>
                                </div>
                            )}

                            {/* ✅ MOVIDO a ParametrosSistema.js (v30728)
                                "Seguridad y Permisos" ahora está en Parámetros del Sistema
                            
                            {permisos.includes('administrarSeguridad') && (
                                <div className="col-lg-3 col-6">
                                    <div className="small-box bg-custom-dark">
                                        <div className="inner">
                                            <h3>&nbsp;</h3>
                                            <p>Seguridad y Permisos</p>
                                        </div>
                                        <div className="icon">
                                            <i className="fas fa-shield-alt"></i>
                                        </div>
                                        <Link to="/security" className="small-box-footer">
                                            Administrar <i className="fas fa-arrow-circle-right"></i>
                                        </Link>
                                    </div>
                                </div>
                            )}
                            */}

                            {/* ❌ DESCARTADO v998 - Menú completo eliminado
                                Funcionalidad "Consecutivos RS" movida a Parámetros del Sistema
                                Ver COMPONENTES_DESCARTADOS_MENU_CONFIGURACION.md
                            
                            {permisos.includes('administrarRips') && (
                                <div className="col-lg-3 col-6">
                                    <div className="small-box bg-custom-dark">
                                        <div className="inner">
                                            <h3>&nbsp;</h3>
                                            <p>Administrar RIPS</p>
                                        </div>
                                        <div className="icon">
                                            <i className="fas fa-file-medical"></i>
                                        </div>
                                        <Link to="/administrar-rips" className="small-box-footer">
                                            Administrar <i className="fas fa-arrow-circle-right"></i>
                                        </Link>
                                    </div>
                                </div>
                            )}
                            */}

                            {/* ✅ MOVIDO a ParametrosSistema.js (v30728)
                                "Información de la Cuenta" ahora está en Parámetros del Sistema
                            
                            {permisos.includes('adminCuenta') && (
                                <div className="col-lg-3 col-6">
                                    <div className="small-box bg-custom-dark">
                                        <div className="inner">
                                            <h3>&nbsp;</h3>
                                            <p>Información de la Cuenta</p>
                                        </div>
                                        <div className="icon">
                                            <i className="fas fa-user-circle"></i>
                                        </div>
                                        <Link to="/cuenta" className="small-box-footer">
                                            Ver Información <i className="fas fa-arrow-circle-right"></i>
                                        </Link>
                                    </div>
                                </div>
                            )}
                            */}

                            {permisos.includes('administrarOpcionesInventario') && (
                                <div className="col-lg-3 col-6">
                                    <div className="small-box bg-custom-dark">
                                        <div className="inner">
                                            <h3>&nbsp;</h3>
                                            <p>Opciones de Inventario</p>
                                        </div>
                                        <div className="icon">
                                            <i className="fas fa-boxes"></i>
                                        </div>
                                        <Link to="/parametros-inventario" className="small-box-footer">
                                            Administrar <i className="fas fa-arrow-circle-right"></i>
                                        </Link>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </section>
            </div>
            <Footer showToast={false} delay={0} />
        </div>
        
    );
}
export default Settings;